/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTailoredResultQueryDto
 */
export interface GetTailoredResultQueryDto {
    /**
     * 
     * @type {string}
     * @memberof GetTailoredResultQueryDto
     */
    priceRatingType: GetTailoredResultQueryDtoPriceRatingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetTailoredResultQueryDto
     */
    tailoredResultType: GetTailoredResultQueryDtoTailoredResultTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetTailoredResultQueryDto
     */
    searchText?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTailoredResultQueryDto
     */
    occupancies?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTailoredResultQueryDto
     */
    countries?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GetTailoredResultQueryDto
     */
    includeTotalRow?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTailoredResultQueryDto
     */
    severity?: GetTailoredResultQueryDtoSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetTailoredResultQueryDto
     */
    peril?: GetTailoredResultQueryDtoPerilEnum;
    /**
     * 
     * @type {string}
     * @memberof GetTailoredResultQueryDto
     */
    currency?: string;
}


/**
 * @export
 */
export const GetTailoredResultQueryDtoPriceRatingTypeEnum = {
    FireRating: 'fire-rating',
    CatRating: 'cat-rating',
    ScheduleOfValues: 'schedule-of-values',
    ScheduleOfValuesFileStatus: 'schedule-of-values-file-status'
} as const;
export type GetTailoredResultQueryDtoPriceRatingTypeEnum = typeof GetTailoredResultQueryDtoPriceRatingTypeEnum[keyof typeof GetTailoredResultQueryDtoPriceRatingTypeEnum];

/**
 * @export
 */
export const GetTailoredResultQueryDtoTailoredResultTypeEnum = {
    FireModifiers: 'fire-modifiers',
    FirePricingSummary: 'fire-pricing-summary',
    FirePricingAnalysis: 'fire-pricing-analysis',
    CatPricingSummary: 'cat-pricing-summary',
    CatPricingAnalysis: 'cat-pricing-analysis'
} as const;
export type GetTailoredResultQueryDtoTailoredResultTypeEnum = typeof GetTailoredResultQueryDtoTailoredResultTypeEnum[keyof typeof GetTailoredResultQueryDtoTailoredResultTypeEnum];

/**
 * @export
 */
export const GetTailoredResultQueryDtoSeverityEnum = {
    Low: 'Low',
    Average: 'Average',
    High: 'High'
} as const;
export type GetTailoredResultQueryDtoSeverityEnum = typeof GetTailoredResultQueryDtoSeverityEnum[keyof typeof GetTailoredResultQueryDtoSeverityEnum];

/**
 * @export
 */
export const GetTailoredResultQueryDtoPerilEnum = {
    Eq: 'EQ',
    Tc: 'TC',
    Fl: 'FL'
} as const;
export type GetTailoredResultQueryDtoPerilEnum = typeof GetTailoredResultQueryDtoPerilEnum[keyof typeof GetTailoredResultQueryDtoPerilEnum];


/**
 * Check if a given object implements the GetTailoredResultQueryDto interface.
 */
export function instanceOfGetTailoredResultQueryDto(value: object): value is GetTailoredResultQueryDto {
    if (!('priceRatingType' in value) || value['priceRatingType'] === undefined) return false;
    if (!('tailoredResultType' in value) || value['tailoredResultType'] === undefined) return false;
    return true;
}

export function GetTailoredResultQueryDtoFromJSON(json: any): GetTailoredResultQueryDto {
    return GetTailoredResultQueryDtoFromJSONTyped(json, false);
}

export function GetTailoredResultQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTailoredResultQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'priceRatingType': json['priceRatingType'],
        'tailoredResultType': json['tailoredResultType'],
        'searchText': json['searchText'] == null ? undefined : json['searchText'],
        'occupancies': json['occupancies'] == null ? undefined : json['occupancies'],
        'countries': json['countries'] == null ? undefined : json['countries'],
        'includeTotalRow': json['includeTotalRow'] == null ? undefined : json['includeTotalRow'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'peril': json['peril'] == null ? undefined : json['peril'],
        'currency': json['currency'] == null ? undefined : json['currency'],
    };
}

export function GetTailoredResultQueryDtoToJSON(json: any): GetTailoredResultQueryDto {
    return GetTailoredResultQueryDtoToJSONTyped(json, false);
}

export function GetTailoredResultQueryDtoToJSONTyped(value?: GetTailoredResultQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceRatingType': value['priceRatingType'],
        'tailoredResultType': value['tailoredResultType'],
        'searchText': value['searchText'],
        'occupancies': value['occupancies'],
        'countries': value['countries'],
        'includeTotalRow': value['includeTotalRow'],
        'severity': value['severity'],
        'peril': value['peril'],
        'currency': value['currency'],
    };
}

